/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [{
      mode: 'modal',
      icon: 'phone',
      color: '#055E68',
      icon_size: 'tawkto',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      font: {
        family: "AUTO"
      },
      devices: ['desktop','laptop','tablet','mobile'],
  }],
  modal_options: {
    header_text: '<img style="margin-top:15px;max-width:300px;" src="https://lirp.cdn-website.com/35b0ce72/dms3rep/multi/opt/IncredibleWindows_VerticalLogo_RGB-211w.jpg">',
    header_color: '#ffffff',
    description_text : 'Ready to transform your space?<br>Our design team is here to help!',
    font: {
      family: "AUTO"
    },
    buttons: [{
      title: '(608) 826-7419',
      link: 'tel:+16088267419',
      txt_color_hover: '#055E68',
      bg_color: '#055E68',
      class_list: [
        "call-us"
      ],
      icon: 'phone'
    }, {
      title: 'WINDOW TREATMENT PLANNING GUIDE',
      link: 'https://www.incrediblewindows.com/planning-guide',
      txt_color_hover: '#055E68',
       bg_color: '#055E68',
      class_list: [
        "window-treatment-planning-guide"
      ],
      icon: 'email'
    }, {
      title: 'CONTACT US',
      link: 'https://www.incrediblewindows.com/contact-us',
      bg_color: '#055E68',
      txt_color_hover: '#055E68',
      class_list: [
        "contact-us"
      ],
      icon: 'email'
    }],
    footer_text: 'Incredible Windows aims to be your premier designer of custom window treatments and motorized window coverings for your home!',
    footer_color: '#055E68'
  }
}).then( _ => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .call-us', action: 'Call Us - ConvertBoost©', event: 'click'}]);
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .window-treatment-planning-guide', action: 'Window Treatment Planning Guide - ConvertBoost©', event: 'click'}]);
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .contact-us', action: 'Contact Us - ConvertBoost©', event: 'click'}]);
});